import {priority} from '@priority-software/priority-proto-api/lib';
import {TreeNodeProps} from '@priority-software/priority-style-react';

const convertColumnToTreeNode = (
    column: priority.netitems.form.IColumn,
    formName: string,
    formTitle: string
): TreeNodeProps => {
    const extraData = {
        shouldDisplay: true,
        formTitle: formTitle
    };
    return {
        title: column.Title,
        id: `${formName}.${column.Name}`,
        isMain: false,
        isExpanded: false,
        isDisabled: false,
        extraData: extraData,
        nodes: null
    };
};

export const serializedTreeResults: (
    res: priority.netitems.nrule.IColumnTreeItem,
    isMain: boolean
) => TreeNodeProps = (res: priority.netitems.nrule.IColumnTreeItem, isMain: boolean) => {
    if (!res) return null;
    const nodes =
        res.Columns?.map(column => convertColumnToTreeNode(column, res.FormName, res.FormTitle)) ||
        [];
    const childNodes = res.ColumnTreeItems?.map(node => serializedTreeResults(node, false)) || [];
    const extraData = {
        shouldDisplay: true,
        formTitle: null
    };
    return {
        title: res.FormTitle,
        id: res.FormName,
        isMain: isMain,
        nodes: nodes.concat(childNodes),
        extraData: extraData,
        isExpanded: isMain
    };
};
